import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
	CFormCheck,
	CFormTextarea,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CPagination,
	CPaginationItem,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 	= require('../../package.json')
const Perawat 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 15) : (uSettingObj.jml_tabel || 30);
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uHtml500msg,setHtml500msg]= React.useState(); 
	const [uTimeelapse,setTimeelapse]= React.useState(0); 
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 			= uHeaderActionObj.isHeaderTambah || false;

	const uDatacabangArr			= JSON.parse(localStorage.getItem("cabanglist")||"[]");

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);
	//--END VIEWS_VARS--/

	//---FORM_VARS--/
	const [uISDlgshowform,setDlgshowform]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});
	//---END FORM_VARS--/

	//--DOM_VARS--/
	const uElJmlData	= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlToggledlg = () =>{ setDlgshowform(false) }

	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		const vCaptionupper = (uDatamainArr[vArridx].perawat_caption||"").toUpperCase();
		setRowselect(vIdxRow);

		setDlgformObj({...uDlgformObj,
			tabelid: _IDTABEL,
			nama_perawat: (uDatamainArr[vArridx].perawat_caption||""),
			telp_hp: ((uDatamainArr[vArridx].telp_hp||"")),
			cabangapprove_arr: uDatamainArr[vArridx].cabangapprove_arr||[],
			dlg_header: ("Edit Data: "+vCaptionupper)
		});
		setDlgshowform(true)
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		const vCaptionupper = (uDatamainArr[vArridx].perawat_caption||"").toUpperCase();
		setRowselect(vIdxRow);

		if(await(Konfirm("Hapus Data: <B>"+vCaptionupper+"</B>"+
			"<BR><BR>Apakah Anda Yakin ?"+
			""))) apiProseshapus(_IDTABEL);
	}
	const hdlKlikDlgsimpan = () => {
		let vElFocus = document.getElementById("inpnamaperawat");
		if((uDlgformObj.nama_perawat||"").trim()==="") {
			vElFocus && vElFocus.focus();
			showToast("Nama Perawat Harus Diisi !");return;
		}

		//--CEK_JML_CABANG--/
		if((uDlgformObj.cabangapprove_arr||[]).length <= 0) {
			vElFocus && vElFocus.focus();
			showToast("Minimal Harus Ada Satu Cabang yang Dipilih !");return;
		}
		//--END CEK_JML_CABANG--/

		apiProsessimpan();
	}
	const hdlKlikcabangall = (_EV) => {
		const vISCabangALLchecked 	= _EV.target.checked;
		const vTabelid				= parseInt(_EV.target.value)||0;

		const vArridx 				= UFunc.getObjectIndeks(uDatamainArr,vTabelid);

		if(vISCabangALLchecked) {
			uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
				cabangtmp_arr: uDatacabangArr.map(vItems=>vItems.id),
			}
		} else {
			uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
				cabangtmp_arr: [],
			}
		}
		apiProsescabang(vTabelid);
		//setEfekview(!uEfekview);
	}
	const hdlKlikcabangid = (_EV,_IDTABEL) => {
		_IDTABEL					= parseInt(_IDTABEL)||0;
		const vISCabangIDchecked 	= _EV.target.checked;
		const vCabangid				= parseInt(_EV.target.value)||0;

		const vArridx 				= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vCabangapproveArr		= (uDatamainArr[vArridx]||{}).cabangapprove_arr || [];

		if(vISCabangIDchecked) {
			(uDatamainArr[vArridx]||{}).cabangtmp_arr = [...vCabangapproveArr,vCabangid];
		} else {
			const vCabangidx 		= UFunc.getObjectIndeks(vCabangapproveArr,vCabangid);

			//vCabangapproveArr.splice(vCabangidx,1);
			(uDatamainArr[vArridx]||{}).cabangtmp_arr = vCabangapproveArr.filter(vItems=>parseInt(vItems)!==vCabangid);
		}
		apiProsescabang(_IDTABEL);
		//setEfekview(!uEfekview);
	}

	//--END HANDEL--/

	//--INIT--/
	const initFormAwal = () => {
		setIDselect(0)
		setDlgformObj({});
	}
	//--END INIT--/

	//--CONTENT--/
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_perawat || "");
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={40} className="px-0 "><small>No</small></th>
			<th className="px-0">
				<CRow className="mx-0">
				<CCol md="2" className="text-start px-0"><small>{uBahasaObj.caption_namaperawat||"Nama Perawat"}</small></CCol>
				<CCol md="2" className="text-start px-0"><small>{uBahasaObj.caption_telphp||"Telp/HP"}</small></CCol>
				<CCol md="6" lg="7" className="text-start px-0"><small>{uBahasaObj.caption_aksescabang||"Akses Cabang"}</small></CCol>
				<CCol md="2" lg="1" className="px-0"><small>&middot;</small></CCol>
				</CRow>
			</th>
			</tr>

			<tr className="d-md-none">
			<th width={30} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,tgl_input,userinput,perawat_caption,telp_hp,cabangapprove_arr,
				init_process,
			} = vItems;

			vNumber++;
			const vCaptionupper	= (perawat_caption||"").toUpperCase();

			const vPerawatcaption	= vKeyword==="" ? (perawat_caption||"") 
				: (perawat_caption||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vTelphp	= vKeyword==="" ? (telp_hp||"-") 
				: (telp_hp||"-").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vUserinput	= vKeyword==="" ? UFunc.Usercaptionfilter((userinput||"UNDF"),1) 
				: (UFunc.Usercaptionfilter((userinput||"UNDF"),1)).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");

			const vISCabangALLchecked 	= (cabangapprove_arr||[]).length >= uDatacabangArr.length;
			const vCabangapproveArr		= uDatacabangArr.filter(vItemcabang=>(cabangapprove_arr||[]).findIndex(vItemapprove=>parseInt(vItemapprove)===parseInt(vItemcabang.id)) >= 0)
			
			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}>
				<td className="px-1 pe-0">{vNumber}.</td>

				<td className="px-1">
				<CRow className="mx-0">
				<CCol md="2" className="px-1 text-start">
					<div className="d-flex justify-content-between">
						<span className="text-capitalize text-info">{UFunc.renderHTML(vPerawatcaption)}</span>
						
						<CDropdown className="d-md-none">
						<CDropdownToggle caret={false} className="p-0" color="transparent">
							<CIcon icon="cilOptions" height={18}/>
						</CDropdownToggle>
						<CDropdownMenu>
							<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
								<CIcon className="classikonedit align-middle me-2" height={25}/>
								{uBahasaObj.caption_editdata||"Edit Data"}
							</CDropdownItem>
							
							{(uIsHapusallow) && (
							<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
								<CIcon className="classikonhapus align-middle me-2" height={25}/>
								{uBahasaObj.caption_hapusdata||"Hapus Data"}
							</CDropdownItem>
							)}
						</CDropdownMenu>
						</CDropdown>
					</div>

					<span className="text-danger d-none d-md-block classfontsmaller">
						<small>[{UFunc.WaktuAngka(tgl_input||"")}
						<span className="mx-1">&middot;</span>
						{UFunc.renderHTML(vUserinput)}]
						</small>
					</span>
				</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol md="2" className="px-1 text-md-start d-none d-md-block">
					<small>{UFunc.renderHTML(vTelphp)}</small>
				</CCol>

				{(telp_hp||"")!=="" && (
				<>
				<CCol xs="5" className="px-1 d-md-none text-start">{uBahasaObj.caption_telphp||"Telp/HP"}</CCol>
				<CCol xs="7" className="px-1 d-md-none">
					<span className="fst-italic">{UFunc.renderHTML(vTelphp)}</span>
				</CCol>
				</>
				)}

				<CCol xs="3" className="px-1 d-md-none text-start"><small>{uBahasaObj.caption_aksescabang||"Cabang"}</small></CCol>
				<CCol xs="9" className="px-1 d-md-none">
					{vCabangapproveArr.length <= 0 ? (
						<>-</>
					) : (
					<>
					{vCabangapproveArr.map((vItemcabang,vKeycabang)=>{
						return (
						<span key={vKeycabang}>
							{vItemcabang.cabang_nama}

							{vKeycabang > 0 && (
							<span className="mx-1">&middot;</span>
							)}
						</span>
						);
					})}
					</>
					)}
				</CCol>

				<CCol md="6" lg="7" className="px-1 text-start d-none d-md-block">
					<div className="d-flex align-items-start">
					<div className="pe-3">
					<input type="checkbox" onChange={(e)=>hdlKlikcabangall(e)} id={"inpcabangall"+id} name={"inpcabangall"+id} value={id} checked={vISCabangALLchecked}/>
					</div>

					<div>
					{uDatacabangArr.map((vItemcabang,vKeycabang)=>{
						const vIScabangchecked = (cabangapprove_arr||[]).findIndex(vItemapprove=>parseInt(vItemapprove)===parseInt(vItemcabang.id)) >= 0;

						return (
						<span key={vKeycabang}>
						{vKeycabang > 0 && (
						<span className="mx-1">&middot;</span>
						)}

						<CBadge color="light" className="border text-dark fw-normal mb-2 px-2">
						<input type="checkbox" onChange={(e)=>hdlKlikcabangid(e,id)} id={"inpcabangid"+id+"_"+vItemcabang.id} name={"inpcabangid"+id} value={vItemcabang.id} checked={vIScabangchecked}/>
						<label htmlFor={"inpcabangid"+id+"_"+vItemcabang.id} className="classcursorpointer align-top ms-1 text-uppercase">{vItemcabang.cabang_nama}</label>
						</CBadge>
						</span>
						);
					})}
					</div>
					</div>
				</CCol>

				<CCol md="2" lg="1" className="px-0 text-md-center d-none d-md-block">
					<CTooltip content={"--"+(uBahasaObj.caption_editdata||"Edit Data")+": "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit classcursorpointer"/>
					</CTooltip>

					{uIsHapusallow && (
						<CTooltip content={"--"+(uBahasaObj.caption_hapusdata||"Hapus Data")+": "+vCaptionupper}>
						<CLink onClick={()=>hdlKlikHapus(id)} className="classikontabel classikonhapus classcursorpointer"/>
						</CTooltip>
					)}
				</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="5" className="px-1 d-md-none text-start">{uBahasaObj.caption_inputby||"Inputby"}</CCol>
				<CCol xs="7" className="px-1 text-danger d-md-none classfontsmaller">
					<small>[{UFunc.WaktuAngka(tgl_input||"")} &middot; {UFunc.renderHTML(vUserinput)}]</small>
				</CCol>
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)
	}
	const contentDlgform = () => {
		if(!uISDlgshowform) return (<></>)//>

		const vCabangapproveArr = uDlgformObj.cabangapprove_arr || [];
		const vClasscabangshowed= ((parseInt(uDlgformObj.tabelid)||0) <= 0) ? "" : " d-md-none";

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
		<CCol xs="4" className="text-md-end">
			<span className="d-none d-md-block">{uBahasaObj.caption_namaperawat||"Nama Perawat"}</span>
			<small className="d-md-none">{uBahasaObj.word_nama||"Nama"}</small>
		</CCol>
		<CCol className="">
			<CFormInput size="sm"
				maxLength={100}
				className="text-capitalize"
				value={uDlgformObj.nama_perawat}
				onChange={(e)=>setDlgformObj({...uDlgformObj,nama_perawat: (e.target.value)})}
				id="inpnamaperawat"/>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="text-md-end">
			<span className="d-none d-md-block">{uBahasaObj.caption_telphp||"Telp/HP"}</span>
			<small className="d-md-none">{uBahasaObj.caption_telphp||"Telp\/HP"}</small>
		</CCol>
		<CCol xs="8" lg="4" className="">
			<CFormInput size="sm"
				maxLength={50}
				value={uDlgformObj.telp_hp}
				onChange={(e)=>setDlgformObj({...uDlgformObj,telp_hp: (e.target.value)})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inptelphp"/>
		</CCol>
		</CRow>

		<div className={"my-3 classborderbottom"+vClasscabangshowed}/>

		<CRow className={"my-2"+vClasscabangshowed}>
		<CCol xs="4" className="text-md-end">
			<CLink
				onClick={()=>{
					if(vCabangapproveArr.length >= uDatacabangArr.length) {
						setDlgformObj({...uDlgformObj,
							cabangapprove_arr: [],
						});
					} else {
						setDlgformObj({...uDlgformObj,
							cabangapprove_arr: uDatacabangArr.map(vItems=>vItems.id),
						});
					}
				}}
				className="classcursorpointer text-underline">
			<span className="d-none d-md-block">{uBahasaObj.caption_aksescabang||"Akses Cabang"}</span>
			<small className="d-md-none">{uBahasaObj.caption_aksescabang||"Akses Cabang"}</small>
			</CLink>
		</CCol>
		<CCol>
			{uDatacabangArr.map((vItemcabang,vKeycabang)=>{
				const vIScabangchecked = vCabangapproveArr.findIndex(vItemapprove=>parseInt(vItemapprove)===parseInt(vItemcabang.id)) >= 0;

				return (
				<span key={vKeycabang}>
				{vKeycabang > 0 && (
				<span className="mx-1">&middot;</span>
				)}

				<CBadge color="light" className="border text-dark fw-normal mb-2 px-2">
					<input type="checkbox" 
						onChange={(e)=>{
							const vISCabangIDchecked 	= e.target.checked;
							const vCabangid				= parseInt(e.target.value)||0;

							if(vISCabangIDchecked) {
								setDlgformObj({...uDlgformObj,
									cabangapprove_arr: [...vCabangapproveArr,vCabangid],
								});
							} else {
								const vCabangidx 		= UFunc.getObjectIndeks(vCabangapproveArr,vCabangid);
								vCabangapproveArr.splice(vCabangidx,1);
								setDlgformObj({...uDlgformObj,
									cabangapprove_arr: vCabangapproveArr,
								});
							}
						}} 
						id={"inpcabangid"+vItemcabang.id} name={"inpcabangid"} value={vItemcabang.id} checked={vIScabangchecked}/>
					<label htmlFor={"inpcabangid"+vItemcabang.id} className="classcursorpointer align-top ms-1 text-uppercase">{vItemcabang.cabang_nama}</label>
				</CBadge>
				</span>
				)//>
			})}
		</CCol>
		</CRow>
		</CForm>
		);//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoaddata = () => {
		setHtml500msg();

		setJmlData(0);
		setDatamainArr([]);
		setIDselect(0);
		setRowselect(-1);
		setPageActive(1);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vKeyword 	= uKeywordObj.kwd_perawat || "";
		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_perawat/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				const vTmpObj = JSON.parse(output_string.dataobject||"[]");
				setDatamainArr(vTmpObj);
				setJmlData((parseInt(vTmpObj.length)||0));

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Perawat - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Perawat - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsessimpan = () => {
		const vBtnsimpan= document.getElementById("btnDialogSimpan");
		vBtnsimpan && (vBtnsimpan.disabled = true)
		setLoading(true)

		/*//--TESTING_FRONTEND--/
		console.log("(Perawat - apiProsessimpan) LEWaT "); 
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parameterstr: JSON.stringify({...uDlgformObj,dlg_header:undefined}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_perawat/pr_simpan";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vBtnsimpan && (vBtnsimpan.disabled = false)
			if(output_string.sukses) {
				if((parseInt(uDlgformObj.tabelid)||0) <= 0) {
					const vTmpObj = {
						id: output_string.tabelid||"255",
						tgl_input: "",
						userinput: uTokenObj.usercaption,
						perawat_caption:uDlgformObj.nama_perawat,
						telp_hp: (uDlgformObj.telp_hp),
						cabangapprove_arr: uDlgformObj.cabangapprove_arr||[],
					}
					setDatamainArr([vTmpObj,...uDatamainArr]);
					setJmlData(uJmlData+1);

					setDlgformObj({...uDlgformObj,
						nama_perawat: "",
						telp_hp: "",
						cabangapprove_arr: [],
					});

					setPageActive(1);
					setRowselect(-1);
					
					if(!isMobile) {
						document.getElementById("inpnamaperawat") && 
							document.getElementById("inpnamaperawat").focus()
					}
					showToast((uBahasaObj.pesan_sukses || "Data Berhasil Disimpan.."),"SUKSES");
				} else {
					const vArridx	= UFunc.getObjectIndeks(uDatamainArr,uDlgformObj.tabelid)
					uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
						perawat_caption: uDlgformObj.nama_perawat,
						telp_hp: uDlgformObj.telp_hp,
						cabangapprove_arr: uDlgformObj.cabangapprove_arr||[],
					};

					hdlToggledlg();
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Perawat - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setDlgshowform(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vBtnsimpan && (vBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Perawat - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsescabang = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		setLoading(true)

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_cabangidstr : JSON.stringify((uDatamainArr[vArridx]||{}).cabangtmp_arr || []),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_perawat/pr_cabang";

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);

				uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
					cabangtmp_arr: undefined,
				}

			showToast(vDATAS,"ERROR");
		},2000); return
		//--END TESTING_FRONTEND--*/

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
					cabangapprove_arr: (uDatamainArr[vArridx]||{}).cabangtmp_arr || [],
					cabangtmp_arr: undefined,
				}
			} else {
				uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
					cabangtmp_arr: undefined,
				}

				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Perawat - apiProseshapus) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
				cabangtmp_arr: undefined,
			}
			setLoading(false);
			console.log("(Perawat - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		setLoading(true)

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_perawat/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				uDatamainArr.splice(vArridx,1);
				setRowselect(-1);
				setJmlData((parseInt(uDatamainArr.length)||0));
			
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Perawat - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Perawat - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
    	
    	apiLoaddata();

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgshowform(false);
    		setDatamainArr([]);
    	}
	},[])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		/*const vKeyword = uKeywordObj.kwd_perawat || "";
		if(vKeyword.length <= 2) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData])
	React.useEffect(()=>{ setRowselect(-1); },[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		apiLoaddata();
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

		setDlgformObj({...uDlgformObj,
			dlg_header: ((uBahasaObj.word_tambah||"Tambah")+" "+uBahasaObj["menus_"+uActiveroute.toLowerCase()])
		})
		setDlgshowform(true);
	},[uHandelTambah])
	/*React.useEffect(()=>{
		//console.log("("+cComponentName+"[uIsScrollBottom]) uIsScrollBottom: "+uIsScrollBottom);
		if(!isMobile) return;
		if(!uIsScrollBottom) return;
		
		const vPageNow	= uPageActive;
		if(vPageNow+1 > uJmlHal) return;
		setPageActive(vPageNow+1);
	},[uIsScrollBottom])//-*/
	React.useEffect(()=>{
		if(!uISDlgshowform) { initFormAwal(); return; }

		//console.log("("+cComponentName+"[uISDlgshowform]) uISDlgshowform 1: "+uISDlgshowform);
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);

			const vElFocus = document.getElementById("inpnamaperawat");
			if(!isMobile) vElFocus && vElFocus.focus();
		},200);
	},[uISDlgshowform])
	//console.log("Perawat - uPageActive => "+JSON.stringify(uPageActive));

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<strong>{uBahasaObj.caption_page500||"Page 500"}</strong>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)

	return (
		<>
		<CCard className="classbgcard">
			<CCardHeader className="d-flex justify-content-between align-items-center">
			<b>{uBahasaObj.caption_listdata||"List Data"}</b>
			
			<div>
				<small className="d-md-none text-primary">[{UFunc.formatAngka(uJmlData)}]</small>
				<span className="d-md-none mx-1">&middot;</span>
				<span className="text-muted classfontsmaller">
					<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
				</span>
			</div>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/>
			</CCardFooter>
			)}
		</CCard>
		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgshowform} 
			dialogHeader={uDlgformObj.dlg_header}
			toggle={hdlToggledlg}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Perawat